export default __webpack_public_path__ + "static/media/bazzle_vm_4.a7e3ccd9.png";